import {Box, Typography} from '@mui/material';

const COLORS = {
    teal: {bg: '#E1F5EE', text: '#1D9E75', border: '#1D9E7544'},
    amber: {bg: '#FAEEDA', text: '#BA7517', border: '#BA751744'},
    coral: {bg: '#FAECE7', text: '#D85A30', border: '#D85A3044'},
};

export default function SeoScoreBadge({grade, score, onClick, size = 'default'}) {
    if (!grade) return null;
    const palette = COLORS[grade.color] || COLORS.amber;
    const isSmall = size === 'small';

    return (
        <Box
            onClick={onClick}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: isSmall ? '3px' : '5px',
                padding: isSmall ? '1px 6px' : '2px 8px',
                borderRadius: 999,
                border: `1px solid ${palette.border}`,
                background: palette.bg,
                cursor: onClick ? 'pointer' : 'default',
                transition: 'opacity .15s',
                '&:hover': onClick ? {opacity: 0.8} : {},
                userSelect: 'none',
                flexShrink: 0,
            }}>
            <Typography sx={{
                fontSize: isSmall ? 10 : 11,
                fontWeight: 800,
                color: palette.text,
                lineHeight: 1,
            }}>
                {grade.grade}
            </Typography>
            {!isSmall && (
                <Typography sx={{
                    fontSize: 10,
                    fontWeight: 600,
                    color: palette.text,
                    opacity: 0.7,
                    lineHeight: 1,
                }}>
                    {score}
                </Typography>
            )}
        </Box>
    );
}
